// Uncomment the below to migrate to statefull component
// import HeaderContainer from './HeaderContainer'
import Header from './Header'

export { Header }
export default Header
// Uncomment the below to migrate to statefull component
// export { HeaderContainer }
// export default { HeaderContainer }



// WEBPACK FOOTER //
// ./src/components/Header/index.js